<script lang="ts" setup>
import { useAttrs } from 'vue'

import type { CardDetails } from '@/types/types'

defineProps<{
  cardDetails: CardDetails
}>()

const attrs$ = useAttrs()
</script>

<template>
  <div
    class="def:text-center def:py-14 def:px-9 def:rounded-custom def:border-2 def:border-gray-850"
    v-bind="attrs$"
  >
    <slot name="card-image"></slot>
    <slot name="card-header">
      <div
        v-html="cardDetails?.title"
        class="def:text-neutral-100 def:text-xl def:font-bold def:leading-normal"
      ></div>
    </slot>
    <slot name="card-description">
      <p
        class="def:text-base def:font-normal def:text-gray-350 def:pt-2.5 def:px-9 def:leading-normal"
      >
        {{ cardDetails?.description }}
      </p>
    </slot>
    <slot name="card-buttons"></slot>
  </div>
</template>
